import { Card, Row, Col } from "antd";

function CardComponent({ data }) {
  return (
    <Row gutter={[16, 16]} justify="start">
      {data.map((item, index) => (
        <Col xs={24} sm={12} md={8} key={index}>
          <Card
            styles={{
              body: {
                display: "flex",
                alignItems: "center",
                paddingTop: "14px",
                paddingBottom: "14px",
              },
            }}
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                // backgroundColor: "#f5f5f5",
                borderRadius: "50%",
                padding: "10px",
                marginRight: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {item?.icon}
            </div>
            <div>
              <h2
                style={{
                  fontSize: "24px",
                  fontFamily: "poppins",
                  fontWeight: "bolder",
                  margin: '0 auto',
                }}
              >
                {item?.number ?? ""}
              </h2>
              <span style={{ color: "#555", fontFamily: "poppins", fontWeight: "bolder", fontSize: "14px", }}>
                {item?.label || ""}
              </span>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default CardComponent;

//pages\student\wallet-summary\index.js

// const stats = [
//   {
//     icon: <FaPlusCircle size={30} color="#1890ff" />,
//     number: `${Number(grandTotal)}.00`,
//     label: "Topups",
//   },
//   {
//     icon: <FaLock size={30} color="#722ed1" />,
//     number: balanceDetails?.lockedBalance,
//     label: "Locked Balance",
//   },
//   {
//     icon: <FaWallet size={30} color="#52c41a" />,
//     number: balanceDetails?.balance,
//     label: "Balance",
//   },
// ];
//     <CardComponent data={stats} />
